import { flexRender } from "@tanstack/react-table";
import classNames from "classnames";
import { memo } from "react";

import type { ColumnDef, Row } from "@tanstack/react-table";
import type { Appointment } from "models";

type AppointmentRowProps = {
  row: Row<Appointment>;
  virtualRowStart: number;
  virtualRowSize: number;
  onRowClick: (appointment: Appointment) => void;
  columns: ColumnDef<Appointment, any>[];
};

export const AppointmentRow = memo(
  ({ row, virtualRowStart, virtualRowSize, onRowClick }: AppointmentRowProps) => {
    const customerWaitingClassNames = classNames({
      "customer-waiting-row": row.original.customer_waiting && row.original.car_in_shop && !row.original.car_out_of_shop,
      "panic-row": row.original.has_panic
    });

    return (
      <tr
        key={row.id}
        onClick={() => onRowClick(row.original)}
        className={customerWaitingClassNames}
        style={{
          position: "absolute",
          top: `${virtualRowStart}px`,
          left: 0,
          width: "100%",
          height: `${virtualRowSize}px`,
          transform: "none",
          display: "table",
          tableLayout: "fixed"
        }}
      >
        {row.getVisibleCells().map(cell => (
          <td
            key={cell.id}
            style={{
              width: cell.column.columnDef.size,
              minWidth: cell.column.columnDef.minSize,
              maxWidth: cell.column.columnDef.maxSize
            }}
            className={`${cell.column.id}_td`}
          >
            {flexRender(cell.column.columnDef.cell, cell.getContext())}
          </td>
        ))}
      </tr>
    );
  },
  (prevProps, nextProps) =>
    prevProps.row.original === nextProps.row.original && prevProps.virtualRowStart === nextProps.virtualRowStart && prevProps.columns === nextProps.columns
);

AppointmentRow.displayName = "AppointmentRow";
